import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const TREATMENT_EFFECTIVENESS_FILTERS = REPORTS_DEFAULT_FILTERS

export const TREATMENT_EFFECTIVENESS_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'percent' | 'count'
}> = [
  {
    id: 'treatment-acceptance-rate',
    title: 'Treatment Acceptance Rate',
    footer: 'Accepted/Diagnosed',
    format: 'percent',
  },
  {
    id: 'completed-vs-diagnosed-rate',
    title: 'Completed vs Diagnosed Rate',
    footer: 'Completed/Diagnosed',
    format: 'percent',
  },
  {
    id: 'total-diagnosed',
    title: 'Total Diagnosed',
    footer: 'Diagnosed Treatments',
    format: 'count',
  },
  {
    id: 'pending-treatments',
    title: 'Pending Treatments',
    footer: 'Pending Treatments',
    format: 'count',
  },
]

export const TREATMENT_STATUS_PIE_COLORS: Record<string, string> = {
  Accepted: 'var(--blue-400)',
  Completed: 'var(--blue-500)',
  Pending: 'var(--orange-300)',
  Rejected: 'var(--gray-400)',
}
